import { InputStroke, ConfidenceTelemetry } from '@eduwrite/shared';
import { OfflineFirstStorage } from '../repositories/OfflineFirstStorage';
import { useAuthStore } from '../store/useAuthStore';
import { useActivityStore } from '../store/useActivityStore';

/**
 * Handles bundling and uploading of student work.
 */
export class SubmissionEngine {
    /**
     * Submits a completed activity.
     */
    static async submitActivity(params: {
        activityId: string;
        studentId: string;
        classId: string;
        strokes: InputStroke[];
        telemetry?: ConfidenceTelemetry;
    }) {
        console.log(`[Submission] Submitting activity ${params.activityId}...`);

        const submission = {
            id: Math.random().toString(36).substring(7),
            activityId: params.activityId,
            studentId: params.studentId,
            classId: params.classId,
            strokes: params.strokes,
            telemetry: params.telemetry,
            createdAt: Date.now(),
            timestamp: Date.now(),
            // Metadata for sync server
            deviceId: useAuthStore.getState().deviceId || 'unknown',
            targetText: useActivityStore.getState().activities[useActivityStore.getState().currentActivityIndex]?.config?.targetText || 'Unknown',
            activityType: useActivityStore.getState().activities[useActivityStore.getState().currentActivityIndex]?.type,
            activityConfig: useActivityStore.getState().activities[useActivityStore.getState().currentActivityIndex]?.config,
        };


        try {
            // Offline Check: If device explicitly reports offline, queue it
            if (typeof (globalThis as any).navigator !== 'undefined' && !((globalThis as any).navigator).onLine) {
                console.log(`[SubmissionEngine] Device offline, queuing task: ${params.activityId}`);
                await OfflineFirstStorage.savePendingSubmission(submission);
                return;
            }

            console.log('[Submission] Success!');
            return submission;
        } catch {
            console.error('[Submission] Failed, saving to offline storage');
            await OfflineFirstStorage.savePendingSubmission(submission);
            return submission; // Still return so UI can proceed
        }
    }
}
